import { Contract } from 'pricing/types';
import { apiContract } from 'utilities/http/api/pricing/apiContract';
import { Nullable } from 'types';

export const fetchContract = async (contractId: number): Promise<Nullable<Contract>> => {
  const respContract = await apiContract.getContract(contractId);

  if (!respContract.isOk) {
    return null;
  }

  const { contract } = respContract.json;
  const totalQuantity =
    contract.breederContractTerms.reduce((prev, curr) => prev + curr.quantity, 0) || 0;

  return { ...contract, totalQuantity };
};
